import React, { useState, useEffect } from 'react'
import RPASubmitHistoryListing from './RPASubmitHistoryListing'
import { connect, useDispatch } from 'react-redux'
import Tooltip from '../../../../../../itrust_common/components/others/Tooltip'
import { visionInsuranceDetailView } from '../../../../../../redux/actions/addOns/rpa/vision_insurance/visionInsuranceAction'
import { syncMemberBenefitLoad } from '../../../../../../redux/actions/addOns/rpa/vision_insurance/visionInsuranceMappingActions'
import DateFormatView from '../../../../../../itrust_common/components/others/DateFormatView'
import SyncMemberBenifit from '../visionInsuranceMapping/mappingFields/SyncMemberBenifit'
import { useLocation } from 'react-router-dom'
import RPAInsuranceVerify from './RPAInsuranceVerify'
import EdiVerification from '../../../EDIClearingHouse/EdiVerification/EdiVerification'
import { getInsuranceType } from '../../../../../../itrust_common/components/HelperFunctions'
import { eligibilityProcessingKey } from '../../../../../../redux/reducers/addOns/rpa/vision_insurance/visionInsuranceReducer'
import { isEdiVerifiedInsurance, isRpaVerifiedInsurance } from '../../../other/AddOnsHelperFunctions'

function RPASubmitHistory(props) {
  const { isOrderView, insuranceType, order, patient, wrapperClasses, visionInsuranceConfig, ediClearingHouseConfig, rpaServices, ediServices, eligibilityProcessing } = props
  const location = useLocation()
  const hideSyncIcon = location.pathname.endsWith('/account_information')
  const dispatch = useDispatch()
  const [activeTab, setActiveTab] = useState(0)

  const canVerify = (name) =>
    isRpaVerifiedInsurance(visionInsuranceConfig, rpaServices, name) || isEdiVerifiedInsurance(ediClearingHouseConfig, ediServices, name)

  const orderInsurances = isOrderView
    ? (order.orders_insurances_attributes || []).filter(({ patient_insurance_attributes: insurance }) =>
      insurance?.expired_vision_insurance_logs?.length || canVerify(insurance?.insurance_name))
    : []
  const selectedInsurance = isOrderView
    ? orderInsurances[activeTab]?.patient_insurance_attributes
    : patient[insuranceType]

  useEffect(() => {
    if (isOrderView && activeTab >= orderInsurances.length) {
      setActiveTab(0)
    }
  }, [isOrderView, activeTab, orderInsurances.length])

  const expired_vision_insurance_logs = isOrderView
    ? selectedInsurance?.expired_vision_insurance_logs
    : patient[insuranceType]?.expired_vision_insurance_logs

  const latestLog = expired_vision_insurance_logs?.[0]
  const isHasBenefits = latestLog?.has_benefits === true
  const hasLogs = expired_vision_insurance_logs?.length > 0
  const insuranceTypeKey = isOrderView ? getInsuranceType(selectedInsurance?.insurance_type) : insuranceType
  const processingPatientId = isOrderView ? order?.patient_id : patient?.id
  const isProcessing = !!eligibilityProcessing?.[eligibilityProcessingKey(processingPatientId, insuranceTypeKey)]

  if (isOrderView && order?.self_pay) return null
  if (isOrderView && !orderInsurances.length) return null
  if (!isOrderView && !hasLogs && !isProcessing) return null

  const getTabLabel = (insurance) => {
    const name = insurance.patient_insurance_attributes?.insurance_name || 'Insurance'
    const type = (insurance.patient_insurance_attributes?.insurance_type || '').includes('Vision') ? 'Vision' : 'Medical'
    return `${name} . ${type}`
  }

  const showInsuranceTabs = isOrderView && orderInsurances.length >= 1
  const verifyBtnClasses = 'font-size-12 py-1 px-3'

  return (
    <div className={wrapperClasses}>
      {showInsuranceTabs &&
        <ul className="nav nav-tabs insurance-eligibility-tabs border-0 mb-0 flex-nowrap overflow-x-auto overflow-y-hidden">
          {orderInsurances.map((insurance, index) =>
            <li className="nav-item" key={insurance.id || index}>
              <a
                href={`#insurance-history-${insurance.id || index}`}
                className={`nav-link px-3 py-2 font-size-12 text-nowrap ${activeTab === index ? 'active' : ''}`}
                onClick={(e) => {
                  e.preventDefault()
                  setActiveTab(index)
                }}
              >
                {getTabLabel(insurance)}
              </a>
            </li>
          )}
        </ul>
      }

      <div
        className={`bg-white border insurance-eligibility-panel d-flex justify-content-between align-items-center py-3 px-4 ${showInsuranceTabs ? 'rounded-top-0 has-tabs' : 'rounded'}`}
      >
        <div className="d-flex flex-column">
          {(hasLogs || isProcessing) ?
            <>
              <span className="d-flex align-items-center flex-wrap">
                <span className="font-weight-500 font-size-14">
                  {latestLog?.service === 'edi' && !isProcessing ? 'iTRUST EDI Clearinghouse' : 'iTRUST Visionary'}
                </span>
                {isProcessing ?
                  <span className="badge badge-info rounded ml-3 font-size-12 d-inline-flex align-items-center">
                    <span className="spinner-border verify-spinner mr-2" role="status" aria-hidden="true" />
                    Processing
                  </span> :
                  <Tooltip
                    tooltipContent={
                      latestLog?.status === 'found'
                        ? ''
                        : typeof latestLog?.error_message === 'string'
                          ? latestLog.error_message
                          : 'Not Founds'
                    }
                  >
                    {latestLog?.status === 'found' ?
                      <span className="badge rounded bg-success ml-3 font-size-12">Found</span> :
                      <span className="badge rounded bg-failed ml-3 font-size-12">Not Found
                        <i className="las la-info-circle ml-2"></i>
                      </span>
                    }
                  </Tooltip>
                }
                {!hideSyncIcon && isHasBenefits && latestLog?.status === 'found' &&
                  <div className="dropdown bg-transparent ml-3">
                    <button
                      type="button"
                      className={`btn btn-primary btn-sm ${verifyBtnClasses}`}
                      data-toggle="dropdown"
                      aria-expanded="false"
                      onMouseDown={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                        dispatch(syncMemberBenefitLoad({ order_id: order?.id, log_id: expired_vision_insurance_logs.find((item) => item.id)?.id }))
                      }}
                    >
                      Sync
                    </button>
                    <div className="dropdown-menu dropdown-menu-right" style={{ width: '400px', padding: 0 }}>
                      <SyncMemberBenifit
                        dispatch={dispatch}
                        expired_vision_insurance_logs={expired_vision_insurance_logs}
                        wrapperClasses="table-hover"
                        orderId={order?.id}
                        onClose={() => document.body.click()}
                      />
                    </div>
                  </div>
                }
              </span>
              {!isProcessing &&
                <p className="font-size-12 text-muted mb-0 mt-2">
                  <DateFormatView dateTime={latestLog?.timestamp} />
                </p>
              }
            </>
            :
            <span className="font-size-12 text-muted">
              No eligibility history found. Click Verify to check insurance.
            </span>
          }
        </div>

        <div className="d-flex align-items-center ml-3">
          {isOrderView && selectedInsurance &&
            <div className="d-flex align-items-center mr-3">
              {visionInsuranceConfig?.visible &&
                <RPAInsuranceVerify
                  key={`rpa-${selectedInsurance.id}`}
                  selectedInsuranceName={selectedInsurance.insurance_name}
                  selectedInsuranceMemberId={selectedInsurance.member_id}
                  insuranceType={getInsuranceType(selectedInsurance.insurance_type)}
                  orderId={order.id}
                  patientId={order.patient_id}
                  order={order}
                  isOrderView={true}
                  btnClasses={verifyBtnClasses}
                  wrapperClasses="align-items-center"
                />
              }
              {ediClearingHouseConfig?.visible &&
                <EdiVerification
                  key={`edi-${selectedInsurance.id}`}
                  selectedInsuranceName={selectedInsurance.insurance_name}
                  selectedInsuranceMemberId={selectedInsurance.member_id}
                  insuranceType={getInsuranceType(selectedInsurance.insurance_type)}
                  orderId={order.id}
                  patientId={order.patient_id}
                  order={order}
                  isOrderView={true}
                  btnClasses={verifyBtnClasses}
                  wrapperClasses="align-items-center"
                />
              }
            </div>
          }
          {hasLogs &&
            <>
              {latestLog?.status === 'found' || latestLog?.file ?
                <span
                  className="text-primary font-size-20 pointer"
                  onClick={() => dispatch(visionInsuranceDetailView({
                    visible: true,
                    file_url: latestLog?.file,
                    id: latestLog?.id,
                    service: latestLog?.service,
                    content_type: latestLog?.content_type
                  }))}
                >
                  <i className="las la-eye"></i>
                </span> :
                <span className="text-danger font-size-20">
                  <i className="las la-eye-slash"></i>
                </span>
              }
              <div className="dropdown bg-transparent ml-4">
                <span className="dropdown-toggle font-size-20 text-primary pointer" role="button" data-toggle="dropdown" aria-expanded="false">
                  <i className="las la-history"></i>
                </span>
                <div className="dropdown-menu dropdown-menu-right width-25 height-18">
                  <h6 className="mx-4 border-bottom py-3 text-primary">History</h6>
                  <RPASubmitHistoryListing dispatch={dispatch} expired_vision_insurance_logs={expired_vision_insurance_logs} wrapperClasses="table-hover" order={order} />
                </div>
              </div>
            </>
          }
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  const { order: { order }, patient: { patient }, organisation: { organisation }, visionInsurance, ediClearingHouse } = state
  return {
    order,
    patient,
    rpaServices: visionInsurance?.services || [],
    ediServices: ediClearingHouse?.services || [],
    visionInsuranceConfig: organisation.add_ons_config?.type?.vision_insurance,
    ediClearingHouseConfig: organisation.add_ons_config?.type?.edi_clearing_house,
    eligibilityProcessing: visionInsurance.eligibilityProcessing || {},
  }
}

export default connect(mapStateToProps)(RPASubmitHistory);
